// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.5003 21L12.5003 15H9C6.79086 15 5 16.7909 5 19V21H12.5003Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.5003 3H1V4.375C1 6.65782 2.07377 8.47896 3.75676 9.69728C5.41388 10.8969 7.63387 11.5 10 11.5H12.5003L12.5003 3ZM8.00195 4.99805V7.00195H5.99805V4.99805H8.00195Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.5003 14.4152L14.5003 20.9861C16.2995 20.8859 17.9676 20.2498 19.332 19.2496L14.5003 14.4152Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.9456 13C22.7415 14.8643 21.9725 16.5529 20.8054 17.8946L15.9136 13L22.9456 13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.8044 6.11394C21.9607 7.45451 22.737 9.14442 22.9444 11L15.9155 11L20.8044 6.11394Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.5003 9.58679L19.3382 4.75167C17.9682 3.73643 16.3088 3.11121 14.5003 3.01347L14.5003 9.58679Z"}}]};

const ShrimpFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shrimp-filled',
    ref,
    icon: element,
  },
));

ShrimpFilledIcon.displayName = 'ShrimpFilledIcon';

export default ShrimpFilledIcon;
